import { createRouter, createWebHashHistory } from "vue-router";
import Cookies from "js-cookie";
const router = createRouter({
    history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
    routes: [{
            path: "/",
            redirect: "/index",
        },
        {
            path: "/index",
            name: "index",
            component: () =>
                import ("@/views/Index.vue"),
            children: [{
                    path: "",
                    redirect: "/index/home",
                },
                {
                    path: "home",
                    component: () =>
                        import ("@/views/Home.vue"),
                },
                {
                    path: "my",
                    component: () =>
                        import ("@/views/My.vue"),
                },
            ]
        },
        {
            path: "/chooseSpace",
            name: "chooseSpace",
            component: () =>
                import ("@/views/ChooseSpace.vue")
        },
        {
            path: "/chooseRoom",
            name: "chooseRoom",
            component: () =>
                import ("@/views/ChooseRoom.vue")
        },
        {
            path: "/bookSeat",
            name: "bookSeat",
            component: () =>
                import ("@/views/BookSeat.vue")
        },
        {
            path: "/bookRoom",
            name: "bookRoom",
            component: () =>
                import ("@/views/BookRoom.vue")
        },
        {
            path: "/bookFavorite",
            name: "bookFavorite",
            component: () =>
                import ("@/views/BookFavorite.vue")
        },
        {
            path: "/mySeatBookings",
            name: "mySeatBookings",
            component: () =>
                import ("@/views/MySeatBookings.vue")
        },
        {
            path: "/myRoomBookings",
            name: "myRoomBookings",
            component: () =>
                import ("@/views/MyRoomBookings.vue")
        },
        {
            path: "/myEntranceBookings",
            name: "myEntranceBookings",
            component: () =>
                import ("@/views/MyEntranceBookings.vue")
        },
        {
            path: "/myViolations",
            name: "myViolations",
            component: () =>
                import ("@/views/MyViolations.vue")
        },
        {
            path: "/myProfile",
            name: "myProfile",
            component: () =>
                import ("@/views/MyProfile.vue")
        },
        {
            path: "/myEvents",
            name: "myEvents",
            component: () =>
                import ("@/views/MyEvents.vue")
        },
        {
            path: "/listNotices",
            name: "listNotices",
            component: () =>
                import ("@/views/ListNotices.vue")
        },
        {
            path: "/noticeDetail/:id",
            name: "noticeDetail",
            component: () =>
                import ("@/views/NoticeDetail.vue")
        },
        {
            path: "/listEvents",
            name: "listEvents",
            component: () =>
                import ("@/views/ListEvents.vue")
        },
        {
            path: "/eventDetail/:id",
            name: "eventDetail",
            component: () =>
                import ("@/views/EventDetail.vue")
        },
        {
            path: "/scanBook",
            name: "scanBook",
            component: () =>
                import ("@/views/ScanBook.vue")
        },
        {
            path: "/bind",
            name: "bind",
            component: () =>
                import ("@/views/Bind.vue")
        },
        {
            path: "/scanLeaveSign",
            name: "scanLeaveSign",
            component: () =>
                import ("@/views/ScanLeaveSign.vue")
        },
        {
            path: "/bookEntrance",
            name: "bookEntrance",
            component: () =>
                import ("@/views/BookEntrance.vue")
        },
    ],
});
const title = JSON.parse(Cookies.get("school")).platformName;
router.beforeEach((to,from,next)=>{
    document.title = title;
    next();
})
export default router;